import { render } from "./TextInput.vue?vue&type=template&id=1096ae7e"
import script from "./TextInput.vue?vue&type=script&lang=ts"
export * from "./TextInput.vue?vue&type=script&lang=ts"
script.render = render

export default script